<template>
  <div class="bq-solutions-main">
    <Wjw v-show="code === '1'"></Wjw>
    <Zhyy v-show="code === '2'"></Zhyy>
    <Qmjk v-show="code === '3'"></Qmjk>
  </div>
</template>
<script>
import Wjw from './Wjw';
import Zhyy from './Zhyy';
import Qmjk from './Qmjk';

export default {
  name: 'solutions',

  data() {
    return {
      code: this.$route.query.id || '1',
    };
  },
  mounted() {
    console.log(this.$route);
  },
  beforeRouteUpdate(to, from, next) {
    // 在当前路由改变，但是该组件被复用时调用
    // 举例来说，对于一个带有动态参数的路径 /foo/:id，在 /foo/1 和 /foo/2 之间跳转的时候，
    // 由于会渲染同样的 Foo 组件，因此组件实例会被复用。而这个钩子就会在这个情况下被调用。
    // 可以访问组件实例 `this`
    this.code = to.query.id;
    next();
  },
  components: {
    Wjw,
    Zhyy,
    Qmjk,
  },
};
</script>

<style lang="less" scoped>
@import '../../../assets/styles/fn.less';

.bq-solutions-main {
  padding-top: 80px;
}
</style>
